/*
创建者 李伟(2018.2.03)
*/
<template>
  <div class="conInner">
    <section id="content_wrapper">
      <div class="data">
        <h2>我的积分获取记录</h2>
      </div>
      <!--温馨提示-->
      <div class="tip" style="margin-bottom:10px">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg">
          <div>
            <h2>温馨提示</h2>
            <p>1、每日签到获得2张现金券</p>
            <!--<p>1、本月累计签到20次奖励10购物积分</p>
            <p>2、本月连续签到每10次就有一次转盘抽奖机会，最高可获得3次抽奖机会。</p>
            <p>3、评论累计不同产品10条奖励5购物积分。</p>-->
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <div class="box">
        <div class="top"></div>
        <div class="body">
          <div class="empty" v-if="!recordList.length">暂无信息</div>
          <table cellspacing="0" cellpadding="0" width="100%" v-if="recordList.length">
            <thead>
              <tr>
                <th>获取日期</th>
                <th>获取原因</th>
                <th>金额(元)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in recordList">
                <td>{{row.create_time}}</td>
                <td>{{row.type}}</td>
                <td>{{row.money}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pager_border" v-if="recordList.length">
          <Page ref="pages" :total="dataTotal" show-total :page-size="pageSize" @on-change="changepage" size="small"
            show-elevator></Page>
        </div>
        <div class="bottom"></div>
      </div>
    </section>
  </div>
</template>
<script>
import { getRecordList } from 'api/user.js';
export default {
  data() {
    return {
      dataTotal: 0,
      pageSize: 10,
      recordList: []
    }
  },
  created() {
    this.getRecordListDate(1);
  },
  methods: {
    changepage(index) {
      this.$refs['pages'].currentPage = index;
      this.getRecordListDate(index);
    },
    getRecordListDate: function (pageNo) {
      let _params = {
        'page': pageNo,
        'pageSize': this.pageSize
      }
      getRecordList(_params).then((json) => {
        if (json.resCode == '1') {
          this.recordList = json.data.list;
          this.dataTotal = json.data.total;
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    }
  }
}
</script>




// WEBPACK FOOTER //
// myShoppingScore.vue?a6015a74